module.exports = __webpack_public_path__ + "static/media/art5.85a275ee.jpg";